import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { updateLessonTableAction } from "../../../redux/actions/lessonTableActions";
import LoadingBtn from "../../../globalComponents/Loading/components/LoadingBtn/LoadingBtn";
import { confirmConsultationAction } from "../../../redux/actions/consultationsActions";

const EduConfirmedCheckbox = ({ data }) => {
  const [isDisabled, setIsDisabled] = useState(true);
  const { user } = useSelector((state) => state.user);
  const { consultationModalLoading } = useSelector(
    (state) => state.consultationModal,
  );
  const [isTargetCard, setIsTargetCard] = useState(false);

  const dispatch = useDispatch();

  const changeEduConfirmStatus = () => {
    if (!isDisabled) {
      dispatch(confirmConsultationAction(data._id));
      setIsTargetCard(true);
    }
  };

  useEffect(() => {
    //   if (user?.role === "super-admin") {
    //     setIsDisabled(false);
    //   }
    //   if (user?.role === "worker") {
    //     const power = user?.profiles?.find(
    //       (item) => item.profile === "lessonTable",
    //     )?.power;
    //     if (power === "all") {
    setIsDisabled(false);
    //     }
    // } else setIsDisabled(true);
  }, [data.status]);

  useEffect(() => {
    if (!consultationModalLoading) setIsTargetCard(false);
  }, [consultationModalLoading]);

  return (
    <>
      {(consultationModalLoading && isTargetCard && <LoadingBtn />) || (
        <form>
          <input
            disabled={isDisabled}
            value={data.isConfirmed}
            style={{ marginRight: "10px" }}
            type="checkbox"
            checked={data.isConfirmed}
            onChange={(e) =>
              changeEduConfirmStatus(e.target.value === "true" ? true : false)
            }
          />
          <span style={{ color: data.isConfirmed ? "#07bc0c" : "#e74c3c" }}>
            {data.isConfirmed ? "Təsdiqlənib" : "Təsdiqlənməyib"}
          </span>
        </form>
      )}
    </>
  );
};

export default EduConfirmedCheckbox;
